import {Grid} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {getGPLUCoverageDefinitionPropertyPaths, getGPLUOptionsBlockPropertyPaths} from '../PropertyPaths';
import { showInflationProtectionOrOptions } from '../../../PlanTemplates/GWL/GWLUtilities';
import { AccelDeathBenefitType } from '../../../PlanTemplates/GWL/gpluConstants';

export const GPLUAccelDeathOptionsBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedCoverageIndex} = useSelector((state: ReducerState) => state.quoteForm);

  const situsStateCd = getQuoteFieldValue<string>('riskStateCd');
  const accelDeathBenefitType = getQuoteFieldValue<string>(
    getGPLUCoverageDefinitionPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex).accelDeathBenefitTypeCd
  );

  const propertyPaths = getGPLUOptionsBlockPropertyPaths(selectedPlan?.planIndex, selectedCoverageIndex);

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'row-options-1'},
      items: [
        {
          key: propertyPaths.isNonForfeitureApplied,
          element: (
            <QuoteFormElement
              elementType="FormControl"
              label="Non-Forfeiture"
              id={propertyPaths.isNonForfeitureApplied}
              checked={true}
              onChange={e => updateQuoteFieldValue(propertyPaths.isNonForfeitureApplied, e.target.checked)}
              controlType="checkbox"
              disabled
            />
          ),
        },
      ],
    },
  ];

  return (
    showInflationProtectionOrOptions(accelDeathBenefitType as AccelDeathBenefitType, situsStateCd) && (
      <FormWrapper title="Options" collapsible withSeparator expanded>
        <Grid container alignItems="center">
          <FormRowGrid rows={rows} />
        </Grid>
      </FormWrapper>
    )
  );
};
